import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["relative"]
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "controls" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "blocks" }
const _hoisted_7 = { class: "actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_el_select_v2 = _resolveComponent("el-select-v2")
  const _component_el_input_number = _resolveComponent("el-input-number")
  const _component_Button = _resolveComponent("Button")
  const _component_Divider = _resolveComponent("Divider")
  const _component_PromptBlock = _resolveComponent("PromptBlock")
  const _component_CollapseGroup = _resolveComponent("CollapseGroup")
  const _component_AddMessage = _resolveComponent("AddMessage")
  const _component_Icon = _resolveComponent("Icon")
  const _component_ScrollBar = _resolveComponent("ScrollBar")

  return (_openBlock(), _createElementBlock("div", {
    class: "editable-prompt",
    relative: $data.loading
  }, [
    ($data.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          class: "loading",
          large: ""
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_select_v2, {
                  modelValue: $data.model,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model) = $event)),
                  class: "model",
                  options: $data.MODELS,
                  size: "large",
                  placeholder: "Select model",
                  teleported: false
                }, null, 8 /* PROPS */, ["modelValue", "options"]),
                _createVNode(_component_el_input_number, {
                  modelValue: $data.temperature,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.temperature) = $event)),
                  class: "temperature",
                  step: 0.1,
                  min: 0,
                  max: 2
                }, {
                  suffix: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createElementVNode("span", null, "°C", -1 /* HOISTED */)
                  ])),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
              ]),
              ($data.name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    ($data.prompt_old)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          small: "",
                          relative: "",
                          primary: "",
                          loading: $data.saving,
                          disabled: !$options.can_save,
                          onClick: $options.save
                        }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode(" Save ")
                          ])),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["loading", "disabled", "onClick"]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createVNode(_component_Divider, { m: "0" })
          ]),
          _createVNode(_component_ScrollBar, { class: "scroller" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_CollapseGroup, {
                  class: "collapse-group",
                  items: $data.prompt_struct,
                  duration: 300
                }, {
                  default: _withCtx(({item, index}) => [
                    (item.type === 'placeholder')
                      ? (_openBlock(), _createBlock(_component_PromptBlock, {
                          key: 0,
                          modelValue: $data.prompt_struct[index].name,
                          "onUpdate:modelValue": $event => (($data.prompt_struct[index].name) = $event),
                          type: item.type,
                          class: _normalizeClass(["block", {first: !index}]),
                          onDelete: $event => ($options.deleteBlock(index))
                        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "type", "class", "onDelete"]))
                      : (_openBlock(), _createBlock(_component_PromptBlock, {
                          key: 1,
                          modelValue: $data.prompt_struct[index].content,
                          "onUpdate:modelValue": $event => (($data.prompt_struct[index].content) = $event),
                          role: item.role,
                          class: _normalizeClass(["block", {first: !index}]),
                          onChangeRole: $event => ($options.changeRole(index, $event)),
                          onDelete: $event => ($options.deleteBlock(index))
                        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "role", "class", "onChangeRole", "onDelete"]))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["items"]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_AddMessage, {
                    onAdd: $options.addMessage,
                    onToggleAdd: $options.toggleAdd
                  }, null, 8 /* PROPS */, ["onAdd", "onToggleAdd"]),
                  _createVNode(_component_Button, {
                    class: "placeholder",
                    small: "",
                    onClick: $options.addPlaceholder
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        icon: "plus",
                        width: "1.8rem",
                        height: "1.8rem",
                        stroke: "var(--gray-700)"
                      }),
                      _cache[4] || (_cache[4] = _createTextVNode(" Placeholder "))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"])
                ])
              ])
            ]),
            _: 1 /* STABLE */
          })
        ], 64 /* STABLE_FRAGMENT */))
  ], 8 /* PROPS */, _hoisted_1))
}